import { useState, useMemo } from 'react';

const useFields = (initialState: any) => {
    // Manages state for a form. formData should always be an object. 
    const [formData, setFormData] = useState(initialState);
    const setForm = useMemo(() => (eventOrAction: any, name: string, value: string, object: Record<string, any>) => {
        if (!eventOrAction) return;
        else if (eventOrAction.target) {
            let newValue: any = eventOrAction.target.value;
            if (eventOrAction.target.className === "MuiAutocomplete-option Mui-focused") {
                //Special case: autoComplete mui component
                newValue = eventOrAction.target.innerText;
            } else if (eventOrAction.target.className === "PrivateSwitchBase-input css-1m9pwf3" ||
                eventOrAction.target.className === "PrivateSwitchBase-input MuiSwitch-input css-j8yymo") {
                //Special case: checkBox mui component or switch component
                newValue = eventOrAction.target.checked
            }
            return setFormData((prevState: any) => {
                return {
                    ...prevState,
                    [eventOrAction.target.name]: newValue
                }
            });
        } else if (eventOrAction === "reset") {
            return setFormData(initialState);
        } else if (eventOrAction === "replaceObj") {
            return setFormData(object);
        } else if (eventOrAction === "replaceKey") {
            return setFormData((prevState: any) => {
                return {
                    ...prevState,
                    [name]: value
                }
            });
        }
    }, []);
    return [formData, setForm];
}

export default useFields;